'use strict';

import {Component, Inject, Input, OnInit, Output, EventEmitter} from 'ng-metadata/core';
import { PickupAnywhereService } from './pickupAnywhereForm.service';
import { FormBuilderEnums } from '../../../../infra/formBuilder/formBuilder.service';
import { UserSessionManagerService } from '../../../../security/userSessionManager.service';
import { NgrsService } from '../ngrs.service';

const he = require('he');
let qrcode = require('qrcode');
const PICKUP_AT_LIBRARY = 'pickupAtLibrary';


@Component({
    selector: 'pickup-anywhere-form',
    templateUrl: 'components/search/fullView/ngrs/pickup-anywhere-form/pickupAnywhereForm.html'
})

export class PickupAnywhereForm implements OnInit {

    private PERSONAL_DELIVERY_HOME = "Home";
    private PERSONAL_DELIVERY_OFFICE = "Office";
    private PERSONAL_DELIVERY_ALL = "All";
    private PERSONAL_DELIVERY_NONE = "None";

    @Input() private pickupinformationdata: Object;
    @Input() private userpreferenceinstitutioncode: Object;
    @Input() private userpreferencelibraryid: Object;
    @Input() private userpreferencechosenplaceradio: string;
    @Output() private hidePickupAnywhereForm = new EventEmitter();
    private _formData: Object = {};
    private _personalDelivery: string;
    private _selectedPickupInformation: {
        institutionCode: string,
        institutionName: string,
        libraryId: string,
        libraryName: string,
        pickupInformationUpdated: boolean,
        chosenPlaceRadio: string,
        isSelected: boolean;
    }
    private _pickupInstitutionField = {
        key: 'pickupInstitution',
        name: 'pickupInstitution',
        mandatory: true,
        value: '',
        mandatoryIndicator: true,
        path: 'pickupInstitution',
        label: 'nui.ngrs.pickup.information.pickupInstitution',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        events: {
            onChange: this.setPickupAnywhereLibrariesLocation.bind(this)
        }
    };

    private _pickupLibraryField = {
        key: 'pickupLibrary',
        name: 'pickupLibrary',
        mandatory: true,
        value: '',
        mandatoryIndicator: true,
        path: 'pickupLibrary',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH
    };

    private _pickupLocation = {
        key: 'pickupLocation',
        name: 'pickupLocation',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
        options:[],
        events: {
            onClick: this.setPickupLocationRadio.bind(this),
            params: []
        }
    }

    private _pickupAtLibrary = {
        name: 'pickupAtLibrary', 
        label: 'nui.ngrs.request.pickup_at_library', 
        value: 'pickupAtLibrary'
    };

    private _homeDelivery = {
        name: 'homeDelivery', 
        label: 'nui.ngrs.request.home_delivery', 
        value: 'homeDelivery'
    };

    private _officeDelivery = {   
        name: 'officeDelivery', 
        label: 'nui.ngrs.request.office_delivery', 
        value: 'officeDelivery' 
    };

    private _showPickupDropdowns: boolean = true;

    constructor(@Inject('loginIcons') public loginIcons,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private pickupAnywhereService: PickupAnywhereService,
                private userSessionManagerService: UserSessionManagerService,
                private ngrsService: NgrsService) {
                    this._selectedPickupInformation = {
                        institutionCode: undefined,
                        institutionName: undefined,
                        libraryId: undefined,
                        libraryName: undefined,
                        isSelected: false,
                        pickupInformationUpdated: false
                    };
    }

    ngOnInit() {
        this.setPickupAnywhereInstitutionsLocation();
        this.initPickupRadioButtons();
        this.$timeout(() => {
            let element = document.querySelector('#pickup_information_form') as HTMLElement;
            if (element) {
                element.setAttribute('tabindex', '-1');
                element.focus();
                element.setAttribute('tabindex', '0');
            }
        }, 100);
    }

    initPickupRadioButtons() {
        if(this.pickupinformationdata &&  this.pickupinformationdata.personalDelivery && this.pickupinformationdata.personalDelivery != null) {
            this._personalDelivery = this.pickupinformationdata.personalDelivery;
        } else {
            this._personalDelivery = this.PERSONAL_DELIVERY_NONE;
        }
            
        if(this._personalDelivery !== this.PERSONAL_DELIVERY_NONE) {
            this._pickupLocation.options.push(this._pickupAtLibrary);
        }

        if(this._personalDelivery === this.PERSONAL_DELIVERY_HOME || this._personalDelivery === this.PERSONAL_DELIVERY_ALL) {
            this._pickupLocation.options.push(this._homeDelivery);
        }

        if (this._personalDelivery === this.PERSONAL_DELIVERY_OFFICE || this._personalDelivery === this.PERSONAL_DELIVERY_ALL) {
            this._pickupLocation.options.push(this._officeDelivery);
        }

        if(this.userpreferencechosenplaceradio) {
            this._formData.pickupLocation = this.userpreferencechosenplaceradio;
            if(this._formData.pickupLocation !== PICKUP_AT_LIBRARY && this._personalDelivery !== this.PERSONAL_DELIVERY_NONE) {
                this._showPickupDropdowns = false;
            }
        } else {
            this._formData.pickupLocation = PICKUP_AT_LIBRARY;
        }
        
    }

    setUserPreference() {
        if(this.userpreferenceinstitutioncode && this.pickupInstitutionField && this.pickupinformationdata 
            && this.pickupinformationdata.pickupInformationList && this.pickupinformationdata.pickupInformationList instanceof Array){
            let selectedPickupInformation: Object = {};
            this.pickupinformationdata.pickupInformationList.forEach(element => {
                if(element.institutionCode && element.institutionCode == this.userpreferenceinstitutioncode){
                    this.pickupInstitutionField.label = element.institutionName;
                    this.pickupInstitutionField.value = element.institutionCode;
                    selectedPickupInformation.institutionCode = element.institutionCode;
                    selectedPickupInformation.institutionName = element.institutionName;
                    if(this.userpreferencelibraryid && this.pickupLibraryField){
                        element.libraryPickupInformation.forEach(library => {
                            if(library.libraryId && library.libraryId == this.userpreferencelibraryid){
                                this.pickupLibraryField.label = library.libraryName;
                                this.pickupLibraryField.value = library.libraryId;
                                selectedPickupInformation.libraryName = library.libraryName;;
                                selectedPickupInformation.libraryId = library.libraryId;
                                return;
                            }
                        });
                    }
                    return;
                }
            });
            selectedPickupInformation.pickupInformationUpdated = false;
            selectedPickupInformation.chosenPlaceRadio = this._formData.pickupLocation;
            this.pickupAnywhereService.setSelectedPickupInformation(selectedPickupInformation);
        }
    }

    public itemsArrayPopulator(){
        this.setPickupAnywhereInstitutionsLocation();
    }

    public setPickupLocationRadio() {
        if(this._formData.pickupLocation !== PICKUP_AT_LIBRARY) {
            this._showPickupDropdowns = false;
        } else {
            this._showPickupDropdowns = true;
        }
    }

    public setPickupAnywhereLibrariesLocation(){
        if(!this._pickupInstitutionField || !this._pickupInstitutionField.key){
            return;
        }
        
        let comboOptions = [];
        if(this.pickupinformationdata && this.pickupinformationdata.pickupInformationList && this.pickupinformationdata.pickupInformationList instanceof Array){
            this.pickupinformationdata.pickupInformationList.forEach(element => {
                if(element.institutionCode == this._formData.pickupInstitution){
                    if(element.libraryPickupInformation && element.libraryPickupInformation instanceof Array){
                        element.libraryPickupInformation.forEach(library => {
                            comboOptions.push({ "label": library.libraryName, "value": library.libraryId});
                        });
                    }
                    return;
                }
            });
        }
        comboOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        this._pickupLibraryField.options = comboOptions;
        if(this.userpreferencelibraryid){
            this.formData.pickupLibrary = this.userpreferencelibraryid;
        }
    }

    private setPickupAnywhereInstitutionsLocation() {
        let comboOptions = [];
        if(this.pickupinformationdata && this.pickupinformationdata.pickupInformationList 
            && this.pickupinformationdata.pickupInformationList instanceof Array){
            this.pickupinformationdata.pickupInformationList.forEach(element => {
                if(element.institutionName && element.institutionCode){
                    comboOptions.push({ "label": element.institutionName, "value": element.institutionCode});
                }
            });
        }
        comboOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        this._pickupInstitutionField.options = comboOptions;
        this._pickupLibraryField.options = [];
        if(this.userpreferenceinstitutioncode){
            this.formData.pickupInstitution = this.userpreferenceinstitutioncode;
            this.setPickupAnywhereLibrariesLocation();
        }
    }

    public submitForm(){
        if(this.isFormValid()){
            this._selectedPickupInformation.institutionCode = this._formData.pickupInstitution;
            this._selectedPickupInformation.libraryId = this._formData.pickupLibrary;
            this._selectedPickupInformation.pickupInformationUpdated = true;            
            this._selectedPickupInformation.isSelected = true;
            this._selectedPickupInformation.chosenPlaceRadio = this._formData.pickupLocation;
            if(this.pickupinformationdata && this.pickupinformationdata.pickupInformationList){
                this.pickupinformationdata.pickupInformationList.forEach(element => {
                    if(element.institutionName && element.institutionCode && element.institutionCode == this._formData.pickupInstitution){
                        this._selectedPickupInformation.institutionName = element.institutionName;
                        if(element.libraryPickupInformation && element.libraryPickupInformation instanceof Array){
                            element.libraryPickupInformation.forEach(library => {
                                if(library.libraryId && library.libraryId == this._formData.pickupLibrary){
                                    this._selectedPickupInformation.libraryName = library.libraryName;
                                    return;
                                }
                            });
                            return;
                        }
                    }
                });
            }
            this.pickupAnywhereService.setSelectedPickupInformation(this._selectedPickupInformation);
            this.hidePickupAnywhereForm.emit('');
        }
    }

    public isFormValid(){
        return this._formData && ((this._formData.pickupInstitution && this._formData.pickupLibrary) || 
                (this._formData.pickupLocation && this._formData.pickupLocation !== PICKUP_AT_LIBRARY));
    }

    public isSignedIn() {
        return !this.userSessionManagerService.isGuest();
    }

    public getSignInLink() {
        return this.ngrsService.signInLinkRequest;
    }

    public cancelForm(event){
        if(event.keyCode === 9){
            event.preventDefault();
            let element = document.querySelector('#pickup_information_form') as HTMLElement;
            if (element) {
                element.focus();
            }
        }else{
            this._selectedPickupInformation.pickupInformationUpdated = false;
            this.pickupAnywhereService.setSelectedPickupInformation(this._selectedPickupInformation);
            this.hidePickupAnywhereForm.emit('');
        }
    }

    private saveKeydownSupport(e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            let element = document.querySelector('#form-close-btn') as HTMLElement;
            if (element) {
                element.focus();
            }
        }
    }

    public get pickupInstitutionField() {
        return this._pickupInstitutionField;
    }

    public get pickupLibraryField() {
        return this._pickupLibraryField;
    }

    public get formData() {
        return this._formData;
    }
    public set formData(value) {
        this._formData = value;
    }

    public clearForm() {
        this._formData = {};
    }    
    
    public get pickupLocation() {
        return this._pickupLocation;
    }

    public get showPickupDropdowns() {
        return this._showPickupDropdowns;
    }

    public get showHomeDelivery() {
        return this._personalDelivery && this._personalDelivery != this.PERSONAL_DELIVERY_NONE;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/pickup-anywhere-form/pickupAnywhereForm.directive.ts